import { Component, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'frontend-update-contents-status',
  templateUrl: './update-contents-status.components.html',
  styleUrls: ['./update-contents-status.components.scss']
})

export class UpdateContentStatusComponent {
  isActive = false;
  public closeEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef
  ) {
  }

  hideModel(event: any) {
    this.closeEvent.emit(event);
    this.bsModalRef.hide();
  }
}
